import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { CmsContentTagService } from '../../../cms-content-tag-base';

@Component({
  selector: 'py-mobile-navigation-services',
  templateUrl: './mobile-navigation-services.component.html',
  standalone: false,
})
export class MobileNavigationServicesComponent implements OnInit {
  @Input() label: string;
  @Input() filterTag: string;
  @Input() labelAntIcon: string;

  public isCollapsed = true;
  taggedPuffs$: Observable<string[]>;

  constructor(private cmsContentTagService: CmsContentTagService) {}

  ngOnInit() {
    this.taggedPuffs$ = this.cmsContentTagService.findUIDsForMasterTagAndFilterTags(
      this.filterTag,
      'PuffComponent',
      'priority-desc,name-asc',
      'services-menu'
    );
  }
}
